import { defineStore } from 'pinia';
import { useState } from '@/composable/useState';
import { SportType } from '@/interface/enum';

export const useSportLeaguePageStore = defineStore('SportLeaguePage', () => {
    const [sportType, setSportType] = useState<SportType>(SportType.Soccer);
    const [leagueIds, setLeagueIds] = useState<number[]>([]);
    const [leagueNames, setLeagueNames] = useState<string[]>([]);

    const setSportLeaguePage = (sportType: SportType, leagueIds: number[], leagueNames: string[]) => {
        if ((leagueIds.length === 0 && leagueNames.length === 0) || sportType === SportType.Unknown) {
            return false;
        }

        setSportType(sportType);
        setLeagueIds(leagueIds);
        setLeagueNames(leagueNames);
        return true;
    };

    return {
        sportType,
        leagueIds,
        leagueNames,
        setSportLeaguePage,
    };
});
